function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 22.5,
  height: 30.5,
  rx: 3.25,
  fill: "white",
  stroke: "#A8B4BA",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 10,
  r: 2,
  fill: "#A8B4BA"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 16,
  r: 2,
  fill: "#A8B4BA"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 22,
  r: 2,
  fill: "#A8B4BA"
});

function SvgKebabButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabButton);
export default __webpack_public_path__ + "static/media/kebabButton.c284b839.svg";
export { ForwardRef as ReactComponent };